import * as ApiConstants from '../constants/Api'
import * as MiscConstants from '../constants/Misc'

export default (state = {}, action) => {
  switch (action.type) {
    case ApiConstants.POST_PHONE_UPDATE_VERIFY_PENDING:
      return { ...state, loading: true }

    case ApiConstants.POST_PHONE_UPDATE_VERIFY_SUCCESS:
      return { ...state, ...action.payload, loading: false }

    case ApiConstants.POST_PHONE_UPDATE_VERIFY_REJECT:
      return { error: action.payload.message, loading: false }

    case MiscConstants.RESET_PHONE_UPDATE:
      return {}

    default:
      return state
  }
}

export const getPhoneVerifySelector = state => state.phone.verify
